import type { CasinoGamesProps, PaginatedGames } from './types';
import { GameStarter } from './useGameStarter';

export const COLUMN_CLASSES: Record<number, string> = {
  4: 'small-block-grid-2 medium-block-grid-4',
  5: 'small-block-grid-2 medium-block-grid-3 large-block-grid-5',
};

export type SectionProps = {
  gameStarter: GameStarter;
  paginatedGames: PaginatedGames;
  common: CasinoGamesProps['common'];
  labelId: string;
};
